// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { FC } from "react";
import { LinkProps } from "react-router-dom";

import { Icon } from "~design-system";

import { ButtonLink } from "../Buttons/ButtonLink";

/**
 * Wrapper around a ReactRouter Link element that styles it like a button
 * and appends an arrow icon. Pass `back` to prepend a left-pointing arrow instead.
 */
export const GoButton: FC<LinkProps & { back?: boolean }> = ({
  back,
  children,
  ...props
}) => {
  return (
    <ButtonLink {...props}>
      {back && <Icon kind="Arrow" size={16} rotate={180} />}
      <span>{children}</span>
      {!back && <Icon kind="Arrow" size={16} />}
    </ButtonLink>
  );
};
